import { render, staticRenderFns } from "./UserUpdate.vue?vue&type=template&id=cfd3646c&scoped=true"
import script from "./UserUpdate.vue?vue&type=script&lang=js"
export * from "./UserUpdate.vue?vue&type=script&lang=js"
import style0 from "./UserUpdate.vue?vue&type=style&index=0&id=cfd3646c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd3646c",
  null
  
)

export default component.exports